import axios from "axios";
import { getApiHeaders } from "../../api/apiHeaders";
//import { I18n } from "react-redux-i18n";
import {
    SETTING_ITEM_SUCCESS,
    SETTING_ITEM_FAILED,
    ///////////////////
    SETTING_UPDATE_SUCCESS,
    SETTING_UPDATE_FAILED,
    SETTING_RESET_SUCCESS,
    ///////////
} from "../types/settingTypes";
import { config } from "../../config";
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import { I18n } from 'react-redux-i18n';
const url_api = config.api.web;

export function success(item) {
    return {
        type: SETTING_ITEM_SUCCESS,
        item: item
    };
}

export function failed(error) {
    return {
        type: SETTING_ITEM_FAILED,
        error: error
    };
}



export function successUpdate(item) {
    return {
        type: SETTING_UPDATE_SUCCESS,
        item: item
    };
}

export function failedUpdate(error) {
    return {
        type: SETTING_UPDATE_FAILED,
        error: error
    };
}

export const updateItem = (data: Object) => async (dispatch) => {
    await axios({
        method: "put",
        url: url_api + "setting/tax",
        data: data.params,
        headers: getApiHeaders(),
    })
        .then(function (response) {
            //console.log(response);
            if (response.status < 300) {
                if (response.data.status === 'Success') {
                    dispatch(successUpdate(response.data.body));
                    alertify.success("Successfull");
                }
                else dispatch(failedUpdate(response.data.body));
            } else {
                dispatch(failedUpdate("try_later"));
            }
        })
        .catch(function (error) {
            //console.log(error);
            if (error.Error) {
                dispatch(failedUpdate("try_later"));
            } else {
                dispatch(failedUpdate("try_later"));
            }
            return;
        });
};

export const sendHolidayTestEmail = (data) => async () => {
    try {
        const response = await axios.post(
            `${url_api}setting/holiday-email/test`,
            { id: data.user_id },
            { headers: getApiHeaders() },
        );
        if (response.status < 300 && response.data.status === 'Success') {
            const email = response.data.body?.email;
            alertify.success(
                email
                    ? I18n.t('settings_holiday_email_test_sent_to', { email })
                    : I18n.t('settings_holiday_email_test_sent'),
            );
            return { success: true, body: response.data.body };
        }
        alertify.error(I18n.t('try_later'));
        return { success: false };
    } catch (error) {
        const message = error.response?.data?.body;
        if (message) {
            alertify.error(typeof message === 'string' ? message : I18n.t('try_later'));
        } else {
            alertify.error(I18n.t('try_later'));
        }
        return { success: false };
    }
};

export const loadItem = (data: Object) => async dispatch => {
    //   dispatch(loading());
    await axios
        .get(url_api + "setting/", {
            params: {
                id: data.user_id,
                //token: data.token,
                //lang: I18n.t("locale")
            },
            headers: getApiHeaders(),
        })
        .then(function (response) {
            //console.log(response);
            if (response.status < 300) {
                if (response.data.status === 'Success')
                    dispatch(success(response.data.body));
                else dispatch(failed(response.data.body));
            } else {
                dispatch(failed("try_later"));
            }
        })
        .catch(function (error) {
            console.log(error);
            if (error.Error) {
                dispatch(failed("try_later"));
            } else {
                dispatch(failed("try_later"));
            }
            return;
        });
};

export const reset = (data: Object) => async (dispatch) => {
    try {
        const response = await axios.delete(`${url_api}setting/`, {
            params: { id: data.params.id },
            data: { password: data.params.password },
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            dispatch({ type: SETTING_RESET_SUCCESS, data: response.data.body });
            alertify.success(I18n.t('reset_success'));
            return { success: true };
        }
        dispatch(failedUpdate(response.data.body || 'try_later'));
        alertify.error(I18n.t('try_later'));
        return { success: false };
    } catch (error) {
        const message = error.response?.data?.body || 'try_later';
        dispatch(failedUpdate(message));
        const errorKey = message === 'Wrong password'
            ? 'wrong_password'
            : (message === 'try_later' ? 'try_later' : message);
        alertify.error(I18n.t(errorKey) !== errorKey ? I18n.t(errorKey) : message);
        return { success: false };
    }
};